export const getFilteredQuizzes = (quizzes, { status, text }) => {
    return quizzes
        .filter((quiz) => text && text != '' ? quiz.name.toLowerCase().includes(text) : true)
        .filter((quiz) => (status ? quiz.status === status : true));
};
